let cartListenerSetup = false;

window.addEventListener("DOMContentLoaded", () => {
  setupCartListener();
});

function generateUUID() {
  var dt = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
  return uuid;
}

function showErrorToast(message) {
  // Remove any existing error toast
  const existingToast = document.getElementById('dynamicErrorToast');
  if (existingToast) {
    existingToast.remove();
  }

  // Create toast container
  const toastContainer = document.createElement('div');
  toastContainer.id = 'dynamicErrorToast';
  toastContainer.style.cssText = 'position: fixed; top: 20px; right: 20px; z-index: 10000;';

  // Create toast content
  toastContainer.innerHTML = `
    <div class="toast-box error-toast">
      <div class="toast-content">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="toast-icon">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        <div class="toast-message">
          <strong>Error</strong>
          <p class="error-message">${message}</p>
        </div>
      </div>
      <button class="toast-close" aria-label="Close notification">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
    <style>
      .toast-box {
        background: white;
        border-radius: 8px;
        padding: 16px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        min-width: 320px;
        max-width: 400px;
        animation: slideInRight 0.3s ease-out;
      }
      .toast-box.error-toast {
        border-left: 4px solid #dc3545;
      }
      .toast-box.fade-out {
        animation: slideOutRight 0.5s ease-out forwards;
      }
      .toast-content {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        flex: 1;
      }
      .toast-icon {
        color: #dc3545;
        flex-shrink: 0;
        margin-top: 2px;
      }
      .toast-message {
        flex: 1;
      }
      .toast-message strong {
        display: block;
        font-size: 14px;
        font-weight: 600;
        color: #212529;
        margin-bottom: 4px;
      }
      .toast-message p {
        margin: 0;
        font-size: 13px;
        color: #6c757d;
        line-height: 1.4;
      }
      .toast-close {
        background: none;
        border: none;
        cursor: pointer;
        padding: 0;
        color: #6c757d;
        flex-shrink: 0;
        transition: color 0.2s ease;
      }
      .toast-close:hover {
        color: #212529;
      }
      @keyframes slideInRight {
        from {
          transform: translateX(400px);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
      @keyframes slideOutRight {
        from {
          transform: translateX(0);
          opacity: 1;
        }
        to {
          transform: translateX(400px);
          opacity: 0;
        }
      }
      @media (max-width: 768px) {
        #dynamicErrorToast {
          top: 10px !important;
          right: 10px !important;
          left: 10px !important;
        }
        .toast-box {
          min-width: auto;
          width: 100%;
        }
      }
    </style>
  `;

  // Add to body
  document.body.appendChild(toastContainer);

  // Add close button functionality
  const closeButton = toastContainer.querySelector('.toast-close');
  closeButton.addEventListener('click', () => {
    closeErrorToast(toastContainer);
  });

  // Auto close after 5 seconds
  setTimeout(() => {
    closeErrorToast(toastContainer);
  }, 5000);
}

function closeErrorToast(container) {
  const toast = container.querySelector('.toast-box');
  if (toast) {
    toast.classList.add('fade-out');
    setTimeout(() => {
      if (container && container.parentNode) {
        container.remove();
      }
    }, 500);
  }
}

function setupCartListener() {
  if (cartListenerSetup) {
    return;
  }

  cartListenerSetup = true;

  const handleCartMessage = async (event) => {
    if (event.data?.type !== "ADD_TO_CART") return;

    if (handleCartMessage.processing) {
      return;
    }

    handleCartMessage.processing = true;

    // Show loader
    const loadingSpinner = document.getElementById('loadingSpinner');
    if (loadingSpinner) {
      loadingSpinner.style.display = 'block';
    }

    let modificationId = generateUUID();

    const { quantity, variantId, customization, fileName, uploadResult } = event.data.payload;

    if (!variantId) {
      console.error("No variant ID provided");
      handleCartMessage.processing = false;
      return;
    }

    // Determine cart items based on customization
    const cartItems = [];
    
    // Check front customization (file OR text)
    const hasFrontFile = customization?.front?.hasFile && customization?.front?.hasCustomization;
    const hasFrontText = customization?.front?.text && customization?.front?.text.trim() !== "";
    const hasFrontCustomization = hasFrontFile || hasFrontText;
    
    // Check back customization (file OR text)
    const hasBackFile = customization?.back?.hasFile && customization?.back?.hasCustomization;
    const hasBackText = customization?.back?.text && customization?.back?.text.trim() !== "";
    const hasBackCustomization = hasBackFile || hasBackText;

    // If there's any customization, add items for each side that has customization
    if (hasFrontCustomization || hasBackCustomization) {
      
      // Get variant IDs from customization sizes
      let frontVariantId = customization?.front?.size?.id;
      let backVariantId = customization?.back?.size?.id;
      
      // Add front customization (file or text)
      if (hasFrontFile) {
        cartItems.push({
          id: frontVariantId,
          quantity: quantity,
          properties: {
            Side: 'Front',
            _type:"Laser",
            _File:uploadResult.files.files.front.webContentLink,
            _modificationId: modificationId,
            "Digital Proof": customization?.front?.screenshotUrl || ''
          }
        });
      } else if (hasFrontText) {
        cartItems.push({
          id: frontVariantId,
          quantity: quantity,
          properties: {
            'Side': 'Front',
            'Text': customization.front.text,
            "_type":"Laser",
            'Font Family': customization.front.fontFamily,
            "_modificationId": modificationId,
            "Digital Proof": customization?.front?.screenshotUrl || ''
          }
        });
      }

      // Add back customization (file or text)
      if (hasBackFile) {
        cartItems.push({
          id: backVariantId,
          quantity: quantity,
          properties: {
            Side: 'Back',
            _type:"Laser",
            _File:uploadResult.files.files.back.webContentLink,
            _modificationId: modificationId,
            "Digital Proof": customization?.back?.screenshotUrl || ''
          }
        });
      } else if (hasBackText) {
        cartItems.push({
          id: backVariantId,
          quantity: quantity,
          properties: {
            'Side': 'Back',
            'Text': customization.back.text,
            "_type":"Laser",
            'Font Family': customization.back.fontFamily,
            "_modificationId": modificationId,
            "Digital Proof": customization?.back?.screenshotUrl || ''
          }
        });
      }
      
      // Add the main product variant
      cartItems.push({
        id: variantId,
        quantity: quantity,
        properties: {
          "_Folder Link": uploadResult?.files?.folderLink || '',
          "_modificationId": modificationId,
          "_type":"Main Product"
        }
      });
      
    } else {
      // No customization, just add the main product
      cartItems.push({
        id: variantId,
        quantity: quantity,
        properties: {}
      });
    }

    // Prepare form data for Shopify cart
    const formData = {
      items: cartItems
    };

    try {
      // Use Shopify Ajax API to add to cart
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.description || data.message || 'Failed to add to cart');
      }

      // Hide loader
      if (loadingSpinner) {
        loadingSpinner.style.display = 'none';
      }

      // Dispatch custom event for cart update
      // Fetch updated cart data
      const cartData = await fetch('/cart.js').then(res => res.json());

      // Dispatch multiple cart update events for different theme compatibility
      window.dispatchEvent(new CustomEvent("cartUpdated", {
        detail: { cart: cartData, items: cartData.items },
      }));

      window.dispatchEvent(new CustomEvent("cart:updated", {
        detail: { cart: cartData },
      }));

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: cartData }
      }));

      document.body.dispatchEvent(new CustomEvent('cart:build', {
        bubbles: true
      }));

      // Trigger Shopify theme cart update methods
      if (typeof theme !== 'undefined') {
        if (theme.cart && typeof theme.cart.getCart === 'function') {
          theme.cart.getCart();
        }
        if (theme.cart && typeof theme.cart.updateView === 'function') {
          theme.cart.updateView();
        }
        if (theme.cartDrawer && typeof theme.cartDrawer.build === 'function') {
          theme.cartDrawer.build();
        }
      }

      // Try to directly update cart drawer content
      const cartDrawerContent = document.querySelector('[data-ajax-cart-section]') || 
                                document.querySelector('.ajax-cart') ||
                                document.querySelector('#CartDrawer');
      
      if (cartDrawerContent) {
        // Trigger a cart section refresh
        const sections = cartDrawerContent.getAttribute('data-section-id') || 'cart-drawer';
        try {
          const sectionResponse = await fetch(`?sections=${sections}`);
          const sectionData = await sectionResponse.json();
          if (sectionData[sections]) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = sectionData[sections];
            const newContent = tempDiv.querySelector('[data-ajax-cart-section]') || 
                              tempDiv.querySelector('.ajax-cart') ||
                              tempDiv.querySelector('#CartDrawer');
            if (newContent && cartDrawerContent.parentNode) {
              cartDrawerContent.parentNode.replaceChild(newContent, cartDrawerContent);
            }
          }
        } catch (e) {
          console.log('Cart section refresh failed:', e);
        }
      }

      // Wait for cart to update
      await new Promise(resolve => setTimeout(resolve, 200));

      // Open cart drawer
      if (typeof Shopify !== 'undefined' && Shopify.theme && Shopify.theme.cartDrawer) {
        Shopify.theme.cartDrawer.open();
      } else if (typeof theme !== 'undefined' && theme.Drawer) {
        theme.Drawer.open('cart');
      } else {
        // Try common cart drawer selectors
        const cartDrawerTrigger = document.querySelector('[data-action="open-drawer"][data-drawer="cart"]') || 
                                  document.querySelector('.js-drawer-open-cart') ||
                                  document.querySelector('[data-cart-drawer]') ||
                                  document.querySelector('a[href="/cart"]');
        if (cartDrawerTrigger) {
          cartDrawerTrigger.click();
        }
      }

    } catch (error) {
      console.error("Error adding to cart:", error);

      // Hide loader on error
      if (loadingSpinner) {
        loadingSpinner.style.display = 'none';
      }

      // Create and show dynamic error toast
      showErrorToast(error.message);

      window.dispatchEvent(
        new CustomEvent("cartUpdateError", {
          detail: { error: error.message },
        })
      );
    } finally {
      setTimeout(() => {
        handleCartMessage.processing = false;
      }, 2000);
    }
  };

  window.addEventListener("message", handleCartMessage);
}

// Global function to close toasts
function closeToast(containerId) {
  const container = document.getElementById(containerId);
  if (container) {
    const toast = container.querySelector('.toast-box');
    if (toast) {
      toast.classList.add('fade-out');
      setTimeout(() => {
        container.style.display = 'none';
      }, 500);
    }
  }
}
